import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  updateFormDate: {
    id: 'course-authoring.course-updates.update-form.date',
    defaultMessage: 'Date',
  },
  updateFormInValid: {
    id: 'course-authoring.course-updates.update-form.inValid',
    defaultMessage: 'Action required: Enter a valid date.',
  },
  updateFormCalendarAltText: {
    id: 'course-authoring.course-updates.update-form.calendar-alt-text',
    defaultMessage: 'Calendar for datepicker input',
  },
  updateFormErrorAltText: {
    id: 'course-authoring.course-updates.update-form.error-alt-text',
    defaultMessage: 'Error icon',
  },
  addNewUpdateTitle: {
    id: 'course-authoring.course-updates.update-form.new-update-title',
    defaultMessage: 'Add new update',
  },
  editUpdateTitle: {
    id: 'course-authoring.course-updates.update-form.edit-update-title',
    defaultMessage: 'Edit update',
  },
  editHandoutsTitle: {
    id: 'course-authoring.course-updates.update-form.edit-handouts-title',
    defaultMessage: 'Edit handouts',
  },
  saveButton: {
    id: 'course-authoring.course-updates.actions.save',
    defaultMessage: 'Save',
  },
  postButton: {
    id: 'course-authoring.course-updates.actions.post',
    defaultMessage: 'Post',
  },
  cancelButton: {
    id: 'course-authoring.course-updates.actions.cancel',
    defaultMessage: 'Cancel',
  },
});

export default messages;
